import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "close_icon",
  "use": "close_icon-usage",
  "viewBox": "0 0 15 15",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15 15\" id=\"close_icon\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M10.46 10.46a.577.577 0 0 1-.817 0L7.5 8.316 5.255 10.56a.577.577 0 0 1-.816-.816l2.244-2.246-2.142-2.142a.577.577 0 0 1 .816-.816l2.142 2.142L9.54 4.644a.577.577 0 1 1 .818.816L8.316 7.5l2.142 2.143a.577.577 0 0 1 0 .816m2.347-8.265C9.881-.731 5.12-.731 2.194 2.194c-2.925 2.926-2.925 7.686 0 10.612 2.926 2.925 7.686 2.925 10.612 0 2.925-2.926 2.925-7.686 0-10.612\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol